import React from 'react';
import { View } from 'react-native';
import { storiesOf } from '@storybook/react-native';
import { PanelHeader, PanelHeaderButton } from 'src/components/PanelHeader';
import { PlatformPadding } from 'src/components/PlatformPadding';
import { Button } from 'src/components/Button';
import Bell from 'src/assets/icons/bell.svg';
import Settings from 'src/assets/icons/settings.svg';
import User from 'src/assets/icons/user.svg';
import { Counter } from 'src/components/Counter';

storiesOf('Counter', module).add('Default', () => (
  <>
    <PanelHeader
      right={
        <>
          <PanelHeaderButton
            label={
              <Counter variant="prominent" size="s">
                1
              </Counter>
            }
          >
            <Bell />
          </PanelHeaderButton>
          <PanelHeaderButton label={<Counter variant="prominent" size="xs" />}>
            <Settings />
          </PanelHeaderButton>
          <PanelHeaderButton
            label={
              <Counter variant="prominent" size="s">
                1
              </Counter>
            }
          >
            <User />
          </PanelHeaderButton>
        </>
      }
    >
      3️⃣ Counter
    </PanelHeader>
    <PlatformPadding vertical horizontal>
      <View>
        <Button variant="primary" size="l" after={<Counter variant="secondary">3</Counter>}>
          Secondary Counter
        </Button>
      </View>
    </PlatformPadding>
    <PlatformPadding vertical horizontal>
      <View>
        <Button
          variant="secondary"
          size="m"
          after={
            <Counter variant="primary" size="s">
              5
            </Counter>
          }
        >
          Primary Small Counter
        </Button>
      </View>
    </PlatformPadding>
  </>
));
